import { render } from "./NeckTrainer.vue?vue&type=template&id=7460accb&scoped=true"
import script from "./NeckTrainer.vue?vue&type=script&lang=js"
export * from "./NeckTrainer.vue?vue&type=script&lang=js"

import "./NeckTrainer.vue?vue&type=style&index=0&id=7460accb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7460accb"]])

export default __exports__